/**
 * Compares two strings based on the current lang in document.
 */
const localeCompare = (str1: string, str2: string) => {
	const { lang } = document.documentElement;

	if (!lang) {
		return str1.localeCompare(str2);
	}

	return str1.localeCompare(str2, lang);
};

export default localeCompare;
